import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';

type Props = {
  executionId: string;
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmFinishCampaignDialog = ({ executionId, handleClose, afterSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const onFinishClick = async () => {
    setLoading(true);

    try {
      const response = await api.delete(`/campaign_execution/${executionId}/finalize`);

      if (response.status === 200) {
        toast.success('Campanha encerrada com sucesso.');
        afterSubmit();
      }
    } catch (error) {
      toast.error('Erro ao encerrar campanha. Tente novamente!');
      datadogRum.addError(new Error('Fail to finalize campaign execution'), {
        error,
        executionId,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja encerrar esta campanha?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                A campanha pode ser encerrada a qualquer momento. Os atendimentos
                em andamento <b>não serão fechados</b> — eles continuam disponíveis
                em "Meus Atendimentos" até serem finalizados individualmente.
                Deseja continuar?
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button
                variant="outline"
                disabled={loading}
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                bg="green.700"
                color="white"
                onClick={onFinishClick}
                loading={loading}
              >
                Finalizar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmFinishCampaignDialog;
